export default {
  name: "Footer",
  components: {},
  data() {
    return {};
  },
  watch: {},
  methods: {
    getMediaIconsColumns() {
      return this.$mq == "mobile" ? "2" : "12";
    },

    getMediaColumns() {
      return this.$mq == "mobile" ? "6" : "12";
    }
  },
  created() {}
};
